<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>{{ $t('gestaocurso.Matriculas') }}</h1>
        </div>
        <div class="flex xs12 sm12 lg3">
          <va-button class="text-right" @click="abrirNovo()"  :color="BuNovo.color" :style="BuNovo"> {{ $t('Geral.Novo') }}</va-button>
        </div>
  </div>

  <div v-if="novo">
          <form @submit.prevent="addFaturas()" >
              <div class="row">
                 <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="matricula"
                      textBy="nome_curso"
                      :options="AllMatriculaAluno"
                      placeholder="Curso"
                    />
                  </div>
                   <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="produtos"
                      textBy="nome"
                      :options="allProdutos"
                      placeholder="Tipo"
                    />
                  </div>

                  <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="matricula.parcelas"
                    placeholder="Cuotas"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="matricula.valor"
                    placeholder="Valor"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                  :label="$t('forms.selects.simple')"
                    v-model="matricula.vencimento"
                    type="date"
                    placeholder="Fecha Vencimento"
                  />
                </div>
                <div class="flex md3 sm12 xs12 text-center">
                    <va-button class="text-right"  color="dark"> {{ $t('Geral.Salvar') }}</va-button>
                </div>
              </div>

          </form>

  </div>
 
    <va-data-table
          :fields="fields"
          :data="allFaturasAluno"
          hoverable
          no-pagination
          >
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">
             

                <va-button v-if="props.rowData.status_pagamento  == 3 "  small color="warning" @click="visualizar_comprovante(props.rowData)" class="ma-0">
                  {{ $t('arealuno.Analise') }}
                </va-button>
                <va-button v-if="props.rowData.status_pagamento == 1 || props.rowData.status_venda == 1"  small color="primary"  class="ma-0">
                  {{ $t('arealuno.Pago') }}
                </va-button>
                 <va-button v-if="props.rowData.status_pagamento == 0 && props.rowData.status_venda == 0"  small color="dark"  class="ma-0">
                  Aberto
                </va-button>

                 <va-button  small color="info" @click="editar_fatura(props.rowData)"  class="ma-0">
                  {{ $t('arealuno.Editar') }}
                </va-button>
              </template>
              
        </va-data-table>



        <!-- Inicio Modal -->
          <div class="modal" v-show="showModal" >
            <div class="modal-wrapper">
              <div class="modal-container">
                <content select="modal-header">
                  <div class="modal-header">
                    <h3 class="text-center">
                      Comprovante
                    </h3>
                  </div>
                </content>
                <hr>
                <br>
              <!-- Inicio Tabela -->
                <div class="scroll flex lg12 text-center">
                      <img class="text-center" style="width: 100%" :src="src">
                </div>
                

                <!-- Fim Tabela -->
          
                <div class="text-center">
                    <va-button @click="showModal = false"  color="info" >Fechar</va-button>
                </div>
              </div>
            </div>
          </div>
          <!-- Fim Modal -->


          <!-- Inicio Modal ver aluno -->
          <div class="modal" v-show="showModalAluno" >
            <div class="modal-wrapper">
              <div class="modal-container">
                <content select="modal-header">
                  <div class="modal-header">
                    <h3 class="text-center">
                      Comprovante
                    </h3>
                    <div class="text-right">
                    <va-button @click="showModalAluno = false"  color="info" >Fechar</va-button>
                </div>
                  </div>
                </content>
                <hr>
                <br>
              <!-- Inicio Tabela -->

          <form @submit.prevent="edit_Fatura()" >
              <div class="row">
                
                   <div class="flex md3 sm12 xs12">
                   <va-select
                      label="Pago"
                    
                      v-model="get_status_venda"
                      textBy="nome"
                      :options="status_pagamento"
                      placeholder="Pago"
                      
                    />
                  </div>

                  <div class="flex md3 sm12 xs12">
                   <va-select
                      label="Eliminar"
                      v-model="get_status"
                      textBy="nome"
                      :options="status_excluir"
                      placeholder="Eliminar"
                    />
                  </div>

             
                <div class="flex md3 sm12 xs12">
                  <va-input
                   label="Valor"
                    v-model="get_valor"
                    placeholder="Valor"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                   label="Data vencimento"
                    v-model="get_data_vencimento"
                    type="date"
                    placeholder="Fecha Vencimento"
                  />
                </div>
                <div class="flex md3 sm12 xs12">
                  <va-input
                   label="Data Pagamento"
                    v-model="get_data_pagamento"
                    type="date"
                    placeholder="Fecha Pagamento"
                  />
                </div>
                <div class="flex md3 sm12 xs12 text-center">
                    <va-button class="text-right"  color="dark"> Salvar </va-button>
                </div>
              </div>

          </form>
            
                

                <!-- Fim Tabela -->
          
                
              </div>
            </div>
          </div>
          <!-- Fim Modal -->

   
</div>

      
 
</template>

<script>
//import cursos from './Cursos'
import url from '../../../store/modules/urls'

export default {
  name: 'matriculaaluno',
  
  components: {
  
  },

  data () {
      return {
        src:"",
        showModal:false,
        showModalAluno:false,
        BuNovo: {
          color:'info',
          'width': '100%',
        }, 
        get_status_venda:'',
        get_status:'',
        get_data_vencimento:'',
        get_data_pagamento:'',
        get_valor:'',
        status_pagamento:[{nome:'Pago',id:'1' },{nome:'Aberto',id:'0' },{nome:'Pendente',id:'3' }],
        status_excluir:[{nome:'Ativo',id:'1' },{nome:'Excluir',id:'0' }],
        matricula: {
         
          aluno_id:'',
          oferta_grade_polo: '',
          parcelas:'',
          valor:'',
          vencimento:'',
        },
        fatura:{
          status_venda:'',
          status:'',
          data_pagamento:'',
          data_vencimento:'',
          valor:'',
          id:''
        },
        matricula_curso:{},
        novo: false,
        produtos:{},
     
      }
    },
    created(){
      this.all();

    },
  computed: {
    
    
    allFaturasAluno (){ return   this.$store.state.alunos.allfaturasaluno },

    AllMatriculaAluno (){ return   this.$store.state.alunos.allmatriculaaluno },
    allProdutos (){ return   this.$store.state.financeiro.allProdutos },

  

    fields () {
            return [{
            name: '__slot:marker',
            width: '30px',
            dataClass: 'text-center',
            }, {
            name: 'nome_curso',
            title: 'Curso',
            }, {
            name: 'nome_produto',
            title: 'Produto',
            },{
            name: 'data_vencimento',
            title: 'Fecha vencimento',
            },{
            name: 'data_pagamento',
            title: 'Fecha pago',
            },{
            name: 'tipo_pagamento',
            title: 'Tipo de pago',
            },{
            name: 'valor',
            title: 'Valor',
            },{
            name: 'acion',
            dataClass: 'text-right',
            title: '',
            
            }, {
            name: '__slot:actions',
            dataClass: 'text-center',
            }]
        },
    },

  methods: {
    visualizar_comprovante(value){
   //  this.src = url.api_admin + "public/storage/comprovante_pagamento/"+ value.caminho 
     this.src = "http://api.ucpvirtual.com.br/storage/comprovante_pagamento/"+ value.caminho 
    
      this.showModal = true
    },

    editar_fatura(value){

        this.fatura = value
      
       this.get_data_vencimento = this.tratarData(value.data_vencimento)
       this.get_data_pagamento = this.tratarData(value.data_pagamento)
       this.get_valor= value.valor
       this.get_fatura_id = value.id

       for(var i = 0; i< this.status_pagamento.length; i++) {
            if(this.status_pagamento[i].id == value.status_venda) {
                this.get_status_venda = this.status_pagamento[i]
            }
        }

          for(var i = 0; i< this.status_excluir.length; i++) {
            if(this.status_excluir[i].id == value.status) {
                this.get_status = this.status_excluir[i]
            }
        }
         
        
        this.showModalAluno=true

      //  console.log(this.fatura.data_vencimento)
    },

    all(){
      this.$store.dispatch('allPolo')
      this.$store.dispatch('allFaturasAluno',this.$store.state.alunos.get_aluno.id)
      this.$store.dispatch('allMatriculaAluno',this.$store.state.alunos.get_aluno.id)
      this.$store.dispatch('allProdutos')

    },
  async  addFaturas(){
      
      let dados = {
        aluno_id: this.$store.state.alunos.get_aluno.id,
        parcelas:this.matricula.parcelas,
        valor:this.matricula.valor,
        data_vencimento:this.matricula.vencimento,
        finan_produto_id: this.produtos.id,
        oferta_grade_aluno_id: this.matricula.id

      }

    await this.$store.dispatch('addFaturas',dados)
       this.matricula = {}
       this.all()
       this.abrirNovo()
    },
    abrirNovo (){
        this.novo = !this.novo
    },

    async  edit_Fatura(){
      
      var dados = {
        id: this.get_fatura_id,
        aluno_id:this.fatura.aluno_id,
        status:this.get_status.id,
        status_venda:this.get_status_venda.id,
        data_pagamento:this.get_data_pagamento,
        valor:this.get_valor,
        data_vencimento:this.get_data_vencimento,
 
      }
   //  console.log(dados)
       await this.$store.dispatch('editFaturas',dados)
       this.all()
        this.showModalAluno=false
  
    },

    tratarData(value){
       
      return this.formatDate(value, 'padrao');

    },
    formatDate(data, formato) {
      if (formato == 'pt-br') {
        return (data.substr(0, 10).split('-').reverse().join('/'));
      } else {
        return (data.substr(0, 10).split('/').reverse().join('-'));
      }
    },
 
  },
}
</script>

<style lang="scss" scoped>

.scroll{
  overflow-y: scroll;
  max-height: 480px;

}
// daqui para baixo é do modal
 .modal {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .5s ease;
  
  &-wrapper {
   // display: table-cell;
    vertical-align: middle;
  }
  
  &-container {
    background: #fff;
    width: 950px;
    min-height: 400px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0);
  //  transition: all .3s ease;
    margin:  auto;
    margin-top: 100px;
    padding: 20px 30px;
  }
  
  &-footer {
    margin-top: 15px;
  }
  
  &-enter, &-leave {
    opacity: 0;
  }
  
  &-enter &-container,
  &-leave &-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
</style>
